import { useFormReadOnly } from '../../../../../common';
import { useConcludeOnboardingQuestionnaire } from '../hooks';
import ConcludeButtonView from './ConcludeButtonView';

export default function ConcludeButton() {
  return (
    <ConcludeButtonView
      {...useConcludeOnboardingQuestionnaire()}
      readOnly={useFormReadOnly()}
    />
  );
}
